import React from 'react';
import { graphql } from 'react-apollo';
import PropTypes from 'prop-types';
import { Spin, Table, Card } from 'antd';

import BasicOrgDetailsForm from '../../forms/BasicOrgDetailsForm';
import CustomerAddressForm from '../../forms/CustomerAddressForm';
import BankAccountForm from '../../forms/BankAccountForm';
import CustomerDocUpload from '../../components/CustomerDocUpload';

import getBasicOrgDetailsQuery from '../../graphql/queries/getBasicOrgDetailsQuery.graphql';

const { Column } = Table;

const OrganizationalDetails = (props) => {
  const { loading, customerAddresses, customerBasicDetails, customerBankAccounts } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  const { docs } = props;
  const showBasicForm = !customerBasicDetails.pan_no;
  const customerId = props.match.params.id;
  return (
    <div>
      <h2 className="page-title">Factsheet - Organizational Details</h2>
      <Card title="Basic Organizational Details" bordered={false} className="ec-card">
        {
          showBasicForm ?
            <BasicOrgDetailsForm id={customerBasicDetails.id} />
            :
            <div>
              <p><b>PAN: </b>{customerBasicDetails.pan_no}</p>
              <p><b>Date of formation/birth: </b>{customerBasicDetails.formation_date}</p>
            </div>
        }
      </Card>
      <Card title="Organizational Documents" bordered={false} className="ec-card">
        <div className="ec-upload-btn-group">
          {
            docs.map((doc) => {
              let isNotAddress = true;
              doc.tags.forEach((tag) => {
                if (tag.tag === 'address') isNotAddress = false;
              });
              if (isNotAddress && !doc.uploaded) {
                return (
                  <div style={{ marginRight: 10 }} key={doc.id}>
                    <CustomerDocUpload task_id={doc.task.id} customerDoc={doc} customer_id={customerId} buttonText={doc.task.title} />
                  </div>
                );
              }
              return null;
            })
          }
        </div>
      </Card>
      <Card title="Addresses" bordered={false} className="ec-card">
        <Table dataSource={customerAddresses} rowKey="id" className="ec-table" pagination={false}>
          <Column
            title="Type"
            dataIndex="type.name"
            key="type"
          />
          <Column
            title="Street address"
            dataIndex="address"
            key="address"
          />
          <Column
            title="City"
            dataIndex="city"
            key="city"
          />
          <Column
            title="State"
            dataIndex="state"
            key="state"
          />
          <Column
            title="Pincode"
            dataIndex="pincode"
            key="pincode"
          />
          <Column
            title="Documents"
            key="documents"
            render={(text, record) => (
              <div>
                {
                  (record.electricity_bill && !record.electricity_bill.uploaded) ?
                    <div style={{ marginBottom: 10 }}>
                      <CustomerDocUpload task_id={record.electricity_bill.task.id} customerDoc={record.electricity_bill} customer_id={customerId} buttonText="Electricity Bill" />
                    </div>
                    :
                    null
                }
                {
                  (record.phone_bill && !record.phone_bill.uploaded) ?
                    <div>
                      <CustomerDocUpload task_id={record.phone_bill.task.id} customerDoc={record.phone_bill} customer_id={customerId} buttonText="Phone Bill" />
                    </div>
                    :
                    null
                }
              </div>
            )}
          />
        </Table>
        <h5 className="ec-form-title">Add New Address</h5>
        <CustomerAddressForm customer_id={customerId} />
      </Card>

      <Card title="Bank Accounts" bordered={false} className="ec-card">
        <Table dataSource={customerBankAccounts} rowKey="id" className="ec-table" pagination={false}>
          <Column
            title="Bank name"
            dataIndex="name"
            key="name"
          />
          <Column
            title="Account no."
            dataIndex="ac_no"
            key="ac_no"
          />
        </Table>
        <h5 className="ec-form-title">Add New Bank Account</h5>
        <BankAccountForm customer_id={customerId} />
      </Card>
    </div>
  );
};

OrganizationalDetails.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    customerAddresses: PropTypes.array,
    customerBasicDetails: PropTypes.shape({
      id: PropTypes.number,
      pan_no: PropTypes.string,
      formation_date: PropTypes.string,
    }),
    customerBankAccounts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      ac_no: PropTypes.string,
    })),
  }).isRequired,
  match: PropTypes.shape({
    // url: PropTypes.string.isRequired,
    // path: PropTypes.string.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  docs: PropTypes.array.isRequired,
};

export default graphql(getBasicOrgDetailsQuery, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(OrganizationalDetails);



// WEBPACK FOOTER //
// ./src/pages/factsheet/OrganizationalDetails.jsx